//primary langauge constants file for the entire codebase

export const languages = {
    "EN" : "English",
    "ES" : "Español"
}
